import React from 'react';
import { Typography } from '@material-ui/core';
import paragraphs from './paragraphs';
import LinkDocumentDialog from '../LinkDocumentDialog';

const PrivacyPolicy = ({ alignLink }) => {
  return (
    <LinkDocumentDialog title="Privacy Policy" alignLink={alignLink}>
      {paragraphs.map(({ strong, words }, i) => (
        <Typography key={i} variant="body2" paragraph>
          <strong>{strong}</strong> {words}
        </Typography>
      ))}
    </LinkDocumentDialog>
  );
};

export default PrivacyPolicy;
